import { captureConversationAccess } from './conversationReads';

const newestReads = new Map();
let listPage = null;
let newestUnreadTotal = null;

// Page of the newest notification-list read, so background refreshes keep a
// navigation the user started.
export const requestedNotificationPage = () => listPage;

// With a `read` kind (list, unread count), only its newest request applies.
// Both kinds carry the unread total, which only the newest of either applies.
export const captureNotificationResponse = (context, read, page) => {
  if (read === 'list' && page) listPage = page;
  const accessIsCurrent = captureConversationAccess(context);
  const token = {};
  // A write (read, delete) computes the total from the one shown when it
  // started: it holds only while no newer read of the total was issued.
  const totalAtStart = newestUnreadTotal;
  if (read) {
    newestReads.set(read, token);
    newestUnreadTotal = token;
  }
  const isCurrent = () =>
    accessIsCurrent() && (!read || newestReads.get(read) === token);
  return {
    isCurrent,
    unreadTotalIsCurrent: () =>
      isCurrent() && newestUnreadTotal === (read ? token : totalAtStart),
    commit(...args) {
      if (isCurrent()) context.commit(...args);
    },
  };
};
